<app-breadcrumb class="mb-2" [items]="breadcrumdItems" />

<app-properties class="w-full h-full" [showBookmarkedProperties]="true" />
